import axios from "axios";
import http from "./../http-common";

export const searchFepks = (q) =>
  http.get(`/fepks/search?q=${encodeURIComponent(q)}&limit=10`).then((r) => r.data);

export const getFepksByFilmmakerId = (filmmakerId) => {
  try {
    return fetch(
      `${process.env.REACT_APP_BACKEND_URL}/fepks/byfilmmaker/${filmmakerId}`,
      { method: "GET" }
    ).then((res) => res.json());
  } catch (error) {
    console.log(error.message);
  }
};

// The logged-in filmmaker's own EPKs: who liked, followed or wants to buy each
// one, and the access requests with each requester's contact details on
// requests[].requester. Needs auth, so it goes through http.
export const getMyFepks = () => http.get("/fepks/mine").then((r) => r.data);

// EPKs the logged-in user asked to see. Each carries only card fields and the
// caller's own entry in requests (the server filters out everyone else's).
export const getMyRequests = (userId) =>
  http.get(`/fepks/getRequestsFepksByUser/${userId}`).then((r) => r.data);

export const getFepksById = (id) => {
  try {
    return fetch(`${process.env.REACT_APP_BACKEND_URL}/fepks/${id}`, {
      method: "GET",
    }).then((res) => res.json());
  } catch (error) {
    console.log(error.message);
  }
};

export const getActorFollowersNumber = async (id) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/users/getfollower/${id}`,
      {
        method: "GET",
      }
    );

    return await response.json();
  } catch (error) {
    console.log(error.message);
  }
};

export const getUserById = async (userId) => {
  try {
    const response = await http.get(`/users/getuser/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user:", error.response?.data || error.message);
    throw error;
  }
}

// api for user is added to request list
export function addToRequests(message, epkId) {
  return http
    .post("/fepks/postRequests", { fepkId: epkId, comment: message })
    .then((res) => res.data);
}

// api for add request message to chat
export const addToChat = async (message, user, filmmakerId) => {
  try {
    const { data } = await http.post("/chat", {
      userId: filmmakerId,
      chatName: `${user.firstName} ${user.lastName}`,
    });
    // save request message to chat message
    if (data) {
      try {
        // const result =
        return await http.post("/message", {
          chatId: data._id,
          content: message,
        });
        // socket.emit("new message", result.data);
      } catch (error) {
        console.log(`message: ${error.message}`);
      }
    }
  } catch (error) {
    console.log(`message: ${error.message}`);
  }
};

// api for approve access request
export const approveRequest = (request) => {
  return http.post("/fepks/approveRequest", request).then((res) => res.data);
};

// api for refuse access request
export const refuseRequest = (request) => {
  return http.post("/fepks/refuseRequest", request).then((res) => res.data);
};

export const getMoviesByActors = async (actorId) => {
  try {
    const response = await http.get(`/fepks/getmoviesbyactor/${actorId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching movies by actor:", error);
    throw error;
  }
};

export const getDeletedFepksByFilmmakerId = (id) =>
  http.get(`/fepks/deleted/${id}`).then((r) => r.data);

export const getMyCollaborations = () =>
  http.get("/fepks/collaborations/mine").then((r) => r.data);

export const listCollaborators = (epkId) =>
  http.get(`/fepks/${epkId}/collaborators`).then((r) => r.data);

export const addCollaborator = (epkId, userId) =>
  http.post(`/fepks/${epkId}/collaborators`, { userId }).then((r) => r.data);

export const removeCollaborator = (epkId, userId) =>
  http.delete(`/fepks/${epkId}/collaborators/${userId}`).then((r) => r.data);

const compressImage = (file, maxDimension = 1600, quality = 0.82) =>
  new Promise((resolve) => {
    if (!file.type.startsWith('image/')) { resolve(file); return; }
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);
    const cleanup = () => URL.revokeObjectURL(objectUrl);
    img.onerror = () => { cleanup(); resolve(file); };
    img.onload = () => {
      cleanup();
      let { width, height } = img;
      if (width > maxDimension || height > maxDimension) {
        if (width > height) { height = Math.round(height * maxDimension / width); width = maxDimension; }
        else { width = Math.round(width * maxDimension / height); height = maxDimension; }
      }
      const canvas = document.createElement('canvas');
      canvas.width = width; canvas.height = height;
      canvas.getContext('2d').drawImage(img, 0, 0, width, height);
      const outName = file.name.replace(/\.[^.]+$/, '.jpg');
      canvas.toBlob(
        (blob) => blob ? resolve(new File([blob], outName, { type: 'image/jpeg' })) : resolve(file),
        'image/jpeg',
        quality
      );
    };
    img.src = objectUrl;
  });

// `token` kept for existing call sites; unused now that http auto-attaches
// the current access token to the presign request.
export const uploadSingleFile = async (file) => {
  try {
    const toUpload = await compressImage(file);
    const { data: { url, key } } = await http.get("/users/presign", {
      params: { mimeType: toUpload.type },
    });
    // This PUT goes straight to the S3 presigned URL, not our backend --
    // must stay on plain axios: http's baseURL/withCredentials/auth header
    // would all be wrong here and would break the presigned-URL signature.
    await axios.put(url, toUpload, { headers: { 'Content-Type': toUpload.type } });
    return key;
  } catch (error) {
    console.error("Error uploading file to S3:", error);
    throw error;
  }
};

// Push the final updated draft to the server
export const updateFepk = async (epkId, updatePayload) => {
  try {
    const response = await http.put(`/fepks/update/${epkId}`, updatePayload);
    return response.data;
  } catch (error) {
    console.error("Error updating EPK:", error);
    throw error;
  }
};
